import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const PayerMappingsTableHeaderComponent: React.FunctionComponent<
    IPayerMappingsTableHeaderComponentProps
> = props => {
    return (
        <div
            className="
                flex items-center px-[16px] py-[8px] gap-[8px]
                sticky top-0 bg-brand-warmLight05 z-10
                md:hidden
            "
        >
            <PrimaryText typography="h6" className="opacity-75 flex-3 mr-[9px]">
                Payer Name
            </PrimaryText>

            <PrimaryText typography="h6" className="opacity-75 flex-2 mr-[9px]">
                Payer ID
            </PrimaryText>

            <PrimaryText typography="h6" className="opacity-75 flex-2 mr-[9px]">
                Nirvana Payer ID
            </PrimaryText>

            {props.withActionsColumn ? <div className="w-[56px]" /> : null}
        </div>
    )
}

interface IPayerMappingsTableHeaderComponentProps {
    withActionsColumn?: boolean
}
